import React from 'react';

const SvgComponent = (props) => (
  <svg viewBox="0 0 18 18" width="1em" height="1em" {...props}>
    <path d="M9 1.5l-9 4 9 4 7.8-3.467V13.5H18v-8l-9-4zm0 9.642l-.609-.271L3 8.475V13.5c0 1.657 2.686 3 6 3s6-1.343 6-3V8.475l-5.391 2.396-.609.271z" />
  </svg>
);

export default SvgComponent;
